import { Table } from "react-bootstrap";
import {
  getSupportedPlayerStatFields,
  PlayerStatField,
  readPlayerStatValue,
} from "./playerStatPayload";

type DynamicPlayerStatPresentationProps = {
  fields: PlayerStatField[];
  value: Record<string, unknown>;
};

const formatStatValue = (value: unknown) => {
  if (
    value === undefined ||
    value === null ||
    (typeof value === "string" && value.trim() === "")
  ) {
    return "-";
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? String(value) : "-";
  }

  return typeof value === "string" ? value : String(value);
};

const DynamicPlayerStatPresentation = ({
  fields,
  value,
}: DynamicPlayerStatPresentationProps) => {
  const supportedFields = getSupportedPlayerStatFields(fields);

  return (
    <Table bordered hover responsive size="sm" className="mb-0">
      <thead>
        <tr>
          <th scope="col">Statistic</th>
          <th scope="col">Value</th>
        </tr>
      </thead>
      <tbody>
        {supportedFields.map((field) => (
          <tr key={field.key}>
            <th scope="row">{field.label}</th>
            <td>{formatStatValue(readPlayerStatValue(value, field.key))}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export type { DynamicPlayerStatPresentationProps };
export default DynamicPlayerStatPresentation;
